module.exports = __webpack_public_path__ + "img/ATRC Platform - Website TCs-08.09db2472.png";